import React from 'react';

import classNames from 'classnames';

type Props = {
  disabled?: boolean;
  className?: string;
  small?: boolean;
  children?: React.ReactNode;
};

export const ActionListIconContainer: React.FC<Props> = ({
  disabled,
  children,
  className,
  small,
}) => (
  <span
    className={classNames('min-h-lg w-lg flex items-center', className, {
      'text-disabled!': disabled,
      'min-h-xmd w-xmd': small,
    })}
  >
    {children}
  </span>
);
